import React, { memo } from 'react';
import Grid from '@mui/material/Grid';
import '../fichierCss/Evenements.css'

interface DescriptionGeneriqueProps {
  description: string;
}

const DescriptionGenerique = memo(({ description }: DescriptionGeneriqueProps) => {
	const paragraphes = String(description ?? '')
		.split(/\n\s*\n/g)
		.map(texte => texte.trim())
		.filter(Boolean);

	return (
		<Grid item xs={12} md={8} style={{ width: '100%', maxWidth: '100%', margin: 0 }}>
			<div style={{ width: '100%', overflowX: 'hidden' }}>
				{paragraphes.length > 0 ? paragraphes.map((texte, index) => (
					<p
						key={index}
						className="text-justify"
						style={{ lineHeight: 1.75, marginBottom: '1rem', whiteSpace: 'normal', wordBreak: 'break-word', overflowWrap: 'anywhere' }}
					>
						{texte}
					</p>
				)) : (
					<p className="text-justify" style={{ lineHeight: 1.75, whiteSpace: 'normal', wordBreak: 'break-word', overflowWrap: 'anywhere' }}>
						{description}
					</p>
				)}
			</div>
		</Grid>
	);
});

 export default DescriptionGenerique;


 